<template>
  <div>
    <Modal :title="title" v-model="modalShow">
      <Spin fix v-if="serverGetting || flavorGetting"></Spin>
      <Alert show-icon type="error" v-else-if="dataGetError">获取数据失败</Alert>
      <div class="req-form" v-else>
        <Form ref="reqForm" :model="reqForm" style="padding-right: 10px" :rules="reqRule">
          <Alert type="error" v-show="errorMsgShow" show-icon>{{ errorMsg }}</Alert>
          <FormItem label="实例名称">
            <Input v-model="serverData.name" :disabled="true" />
          </FormItem>
          <FormItem label="实例类型 (类型名|内核|内存|磁盘)" prop="new_size">
            <tooltip placement="right" transfer max-width="200">
              <Icon type="ios-help-circle-outline" size="18" />
              <div slot="content">
                <p>新的实例类型中的磁盘大小必须大于或等于当前实例类型中磁盘的大小！</p>
              </div>
            </tooltip>
            <Select v-model="reqForm.flavorRef" transfer>
              <Option v-for="item in flavorList" :key="item.id" :value="item.id">
                {{ item.name }} | {{ item.vcpus }}核 | {{ item.ram }}M | {{ item.disk }}GB {{ serverData.flavor && serverData.flavor.id === item.id ? '(当前)' : '' }}
              </Option>
            </Select>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="submitting">提交</Button>
        <Button @click="modalShow = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { actionPrivateCloudServer, detailPrivateCloudServer } from '@/api/private-cloud/server'
import { getPrivateCloudAllFlavor } from '@/api/private-cloud/flavor'
export default {
  name: 'server-resize',
  data () {
    return {
      title: '调整实例大小',
      flavorList: [],
      serverData: {},
      modalShow: false,
      submitting: false,
      reqForm: {
        flavorRef: null
      },
      reqRule: {
        flavorRef: [
          { required: true, message: '请选择新的实例类型', trigger: 'blur' }
        ]
      },
      errorMsg: '',
      errorMsgShow: false,
      serverGetting: false,
      flavorGetting: false,
      dataGetError: false
    }
  },
  methods: {
    openModal (id) {
      this.dataGetError = false
      this.serverGetting = true
      this.modalShow = true
      this.getFlavorList()
      detailPrivateCloudServer(id).then(res => {
        this.serverData = res.data.server
        if (this.serverData.flavor) {
          this.reqForm.flavorRef = this.serverData.flavor.id
        }
        this.serverGetting = false
      }).catch(res => {
        this.serverGetting = false
        this.dataGetError = true
        console.error(res.response)
      })
    },
    getFlavorList () {
      this.flavorGetting = true
      getPrivateCloudAllFlavor().then(res => {
        this.flavorList = res.data
        this.flavorGetting = false
      }).catch(res => {
        this.flavorGetting = false
        this.dataGetError = true
        console.error(res.response)
      })
    },
    submit () {
      this.$refs['reqForm'].validate((valid) => {
        if (valid) {
          let reqData = {
            'resize': this.reqForm
          }
          this.submitting = true
          actionPrivateCloudServer(reqData, this.serverData.id).then(res => {
            this.modalShow = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.submitting = false
            this.$emit('callback')
          }).catch(res => {
            this.submitting = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！'
              this.$Notice.error({
                title: '操作失败！'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .req-form {
    max-height: 650px;
    overflow-y: auto;
  }
  .req-form::-webkit-scrollbar {
    width: 5px;
  }
  .req-form::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .req-form::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
